import { Dependencies, EmployeeMbrad } from "../models"
import { dependencyGender } from "./DependencyGender"

type Filter = "orgUnits" | "positions" | "costCenters" | "employeeTypes" | "genders"

export type FilterGroup = Record<Filter, string[] | null>

export interface FiltersValue {
    filterGroups: FilterGroup[]
    includedEmployees: EmployeeMbrad[]
    excludedEmployees: EmployeeMbrad[]
}

export function emptyFilters(): FiltersValue {
    return { filterGroups: [], includedEmployees: [], excludedEmployees: [] }
}

export function toDependencies(value: FiltersValue, stored?: Dependencies | null): Dependencies | null {
    // Ništa nije ciljano -> null. API to čita kao "vidljivo svima" i preskače provjeru kategorija;
    // prazan objekt bi i dalje tražio barem jednu aktivnu kategoriju.
    if (!value.filterGroups.length && !value.includedEmployees.length && !value.excludedEmployees.length) {
        return null
    }

    const storedGroups = stored?.filterGroups ?? []

    return {
        filterGroups: value.filterGroups.map((g, i) => {
            const prev = storedGroups[i]
            return {
                orgUnits: g.orgUnits ? { orgUnitIds: g.orgUnits } : null,
                positions: g.positions ? { positions: g.positions } : null,
                costCenters: g.costCenters
                    ? { costCenters: g.costCenters, types: prev?.costCenters?.types ?? [] }
                    : null,
                contracts: g.employeeTypes
                    ? { subTypes: g.employeeTypes, types: prev?.contracts?.types ?? [] }
                    : null,
                genders: g.genders,
            }
        }),
        includedEmployees: _employeeIds(value.includedEmployees, stored?.includedEmployees),
        excludedEmployees: _employeeIds(value.excludedEmployees, stored?.excludedEmployees),
    }
}

export function fromDependencies(
    dependencies: Dependencies | null | undefined,
    employees: EmployeeMbrad[]
): FiltersValue {
    if (!dependencies) return emptyFilters()

    const included = new Set(dependencies.includedEmployees ?? [])
    const excluded = new Set(dependencies.excludedEmployees ?? [])

    return {
        filterGroups: (dependencies.filterGroups ?? []).map(g => ({
            orgUnits: g.orgUnits?.orgUnitIds ?? null,
            positions: g.positions?.positions ?? null,
            costCenters: g.costCenters?.costCenters ?? null,
            employeeTypes: g.contracts?.subTypes ?? null,
            genders: g.genders?.map(dependencyGender) ?? null,
        })),
        includedEmployees: employees.filter(e => included.has(e.masterId)),
        excludedEmployees: employees.filter(e => excluded.has(e.masterId)),
    }
}

function _employeeIds(picked: EmployeeMbrad[], stored: string[] | null | undefined): string[] | null {
    if (picked.length === 0 && (stored === null || stored === undefined)) return null
    return picked.map(e => e.masterId)
}
